// jQuery is loaded once as a classic script (public/js/jquery.min.js); every bundle and npm plugin must share that instance.
module.exports = window.jQuery;
